import { context } from "../../components/wr-context";
export var create = function(v) {
    return {
        url: "".concat(context.constants.sso.host, "/api/v1/sso/act/create"),
        method: "POST",
        body: JSON.stringify({
            data: v
        })
    };
};
export var query = function(v) {
    return {
        url: "".concat(context.constants.sso.host, "/api/v1/sso/act/read"),
        method: "POST",
        body: JSON.stringify({
            data: {
                query: v
            }
        })
    };
};
export var find = function(v) {
    return {
        url: "".concat(context.constants.sso.host, "/api/v1/sso/act/read"),
        method: "POST",
        body: JSON.stringify({
            data: {
                find: v
            }
        })
    };
};
export var getById = function(v) {
    return {
        url: "".concat(context.constants.sso.host, "/api/v1/sso/act/read"),
        method: "POST",
        body: JSON.stringify({
            data: Array.isArray(v) ? {
                ids: v
            } : {
                id: v
            }
        })
    };
};
export var update = function(v) {
    return {
        url: "".concat(context.constants.sso.host, "/api/v1/sso/act/update"),
        method: "POST",
        body: JSON.stringify({
            data: v
        })
    };
};
export var deleteById = function(v) {
    return {
        url: "".concat(context.constants.sso.host, "/api/v1/sso/act/delete"),
        method: "POST",
        body: JSON.stringify({
            data: v
        })
    };
};
